import { useCallback, useMemo, useState } from 'react';
import { Box, ButtonBase, InputBase, makeStyles } from '@material-ui/core';
import _ from 'lodash';
import Dialog from '../../../../components/Dialog';
import { CloseIcon, DeleteIcon } from '../../../../components/Icon';
import { NEW_BED_STATUS_LENGTH } from '../../../../comm/constant';

const useStyles = makeStyles(() => ({
  title: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '0.875rem',
    color: '#538fff',
    textTransform: 'uppercase',
  },
  content: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: '#2e4469',
  },
  bedNo: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.125rem',
    color: '#2e4469',
  },
  input: {
    width: '100%',
    height: '3.5rem',
    padding: '1.25rem',
    border: 'solid 1px #e4e7eb',
    borderRadius: '10px',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
  },
  list: {
    overflowY: 'auto',
    maxHeight: '30rem',
  },
  deleteItemBtn: {
    width: '1.5rem',
    height: '1.5rem',
  },
  closeIcon: {
    fontSize: '1rem',
    color: '#538fff',
  },
}));

const initLink = (links) => {
  return _.map(links, (item) => ({
    ...item,
    linkedBedName: item.bedNo,
  }));
};

const LinkAllRelatedBed = ({ links, handleClose, handleWaitCreateLinkedBed }) => {
  const classes = useStyles();
  const [form, setForm] = useState(initLink(links));

  const handleForm = useCallback(
    (bedNo) => (e) => {
      setForm((o) => {
        const index = _.findIndex(o, (item) => item.bedNo === bedNo);
        o[index].linkedBedName = e.target.value;
        return [...o];
      });
    },
    []
  );

  const handleDelete = useCallback(
    (bedNo) => () => {
      setForm((o) => {
        return _.filter(o, (item) => item.bedNo !== bedNo);
      });
    },
    []
  );

  const handleDeleteItem = useCallback(
    (bedNo, ccWardCd) => () => {
      setForm((o) => {
        let newForm = _.map(o, (item) => {
          if (item.bedNo === bedNo) {
            return {
              ...item,
              links: _.filter(item.links, (linkBedItem) => linkBedItem.ccWardCd !== ccWardCd),
            };
          } else {
            return item;
          }
        });

        return _.filter(newForm, (item) => item.links.length > 0);
      });
    },
    []
  );

  const disabled = useMemo(() => {
    return form.length === 0;
  }, [form]);

  const handleSubmit = useCallback(() => {
    handleWaitCreateLinkedBed(form, handleClose);
  }, [handleWaitCreateLinkedBed, form]);

  return links.length > 0 ? (
    <Dialog
      open={true}
      title="Link All Related Bed"
      cancel="Cancel"
      confirm="Confirm"
      cancelStyle={{ border: 'unset' }}
      dialogfootStyle={{
        paddingTop: '1rem',
        paddingBottom: '0',
        borderTop: 'solid 1px #e4e7eb',
        marginTop: '0',
        transform: 'translate(0, -1px)',
      }}
      handleCancel={handleClose}
      handleClose={handleClose}
      handleConfirm={handleSubmit}
      disabled={disabled}
    >
      <Box display="flex" flexDirection="column">
        <div className={classes.content}>Please confirm if all the following beds are linked</div>
      </Box>
      <Box className={classes.title} display="flex" gridGap="1rem" mt="2rem">
        <Box flexBasis="30%">original bed no.</Box>
        <Box flexBasis="30%">Linked bed no.</Box>
        <Box flexBasis="30%">Linked bed name</Box>
        <Box flexBasis="10%" />
      </Box>
      <Box className={classes.list}>
        {form.map((item) => (
          <Box
            className={classes.bedNo}
            display="flex"
            gridGap="1rem"
            padding="0.75rem 0"
            borderBottom="solid 1px #e4e7eb"
            key={`${item.ccWardCd}, ${item.bedNo}`}
          >
            <Box
              display="flex"
              alignItems="center"
              flexBasis="30%"
              height="3.5rem"
            >{`${item.ccWardCd}, ${item.bedNo}`}</Box>
            <Box display="flex" flexDirection="column" flexBasis="30%">
              {item.links.map((linkBedItem) => (
                <Box
                  display="flex"
                  alignItems="center"
                  height="3.5rem"
                  gridGap="0.5rem"
                  key={`${linkBedItem.ccWardCd}, ${linkBedItem.bedNo}`}
                >
                  {`${linkBedItem.ccWardCd}, ${linkBedItem.bedNo}`}
                  <ButtonBase
                    className={classes.deleteItemBtn}
                    onClick={handleDeleteItem(item.bedNo, linkBedItem.ccWardCd)}
                  >
                    <CloseIcon className={classes.closeIcon} />
                  </ButtonBase>
                </Box>
              ))}
            </Box>
            <Box display="flex" alignItems="center" flexBasis="30%" height="3.5rem">
              <InputBase
                className={classes.input}
                value={item.linkedBedName}
                onChange={handleForm(item.bedNo)}
                inputProps={{ maxLength: NEW_BED_STATUS_LENGTH.LINKED_BED_NAME }}
              />
            </Box>
            <Box display="flex" alignItems="center" justifyContent="center" flexBasis="10%" height="3.5rem">
              <ButtonBase onClick={handleDelete(item.bedNo)}>
                <DeleteIcon />
              </ButtonBase>
            </Box>
          </Box>
        ))}
      </Box>
    </Dialog>
  ) : (
    <Dialog open={true} title="Reminder" confirm="Back" handleConfirm={handleClose} handleClose={handleClose}>
      <div className={classes.content} style={{ marginBottom: '5rem' }}>
        There are no matching bed numbers for linking.Please drag a bed to link with other bed.
      </div>
    </Dialog>
  );
};

export default LinkAllRelatedBed;
